/* is production */
const isProd = process.env.NODE_ENV === 'production';



import axios from 'axios';
import dialogPolyfill from 'dialog-polyfill';
import PerfectScrollbar from 'perfect-scrollbar';
import Chartist from 'chartist';
import 'chartist-plugin-tooltips';
import convert from 'xml-js';



const analyticsEvent = (category, action, label) => {
    const dataLayer = window.dataLayer = window.dataLayer || [];

    dataLayer.push({
        event: 'eventTracking',
        category: category,
        action: action,
        label: label
    });
};



/* news */
axios({
    method: 'get',
    url: 'https://www.gazeta.ru/export/rss/rambler-business-news.xml'
}).then(res => {
    if (res.data.length > 0) {
        const newsArrayRaw = convert.xml2js(res.data, {compact: true, spaces: 4, nativeType: true});

        const newsArray = newsArrayRaw.rss.channel.item;

        if (newsArray.length > 0) {

            document.querySelector('.news').innerHTML = newsArray.reduce((accumulator, currentValue, index) => {
                if (index < 30) {
                    const date = new Date(currentValue.pubDate._text);
                    accumulator += `<li class="news__item"><a href="${currentValue.link._text}" target="_blank" rel="noopener" class="news__link"><time class="news__time" datetime="${date.toString()}" title="${date.toString()}">${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}</time><strong class="news__title">${currentValue.title._cdata}</strong></a></li>`;
                }
                return accumulator;
            }, '');

            [...document.querySelectorAll('.news__link')].forEach(link => {
                link.addEventListener('click', () => {
                    analyticsEvent('News', 'click', `News: ${link.textContent}, URL: ${link.getAttribute('href')}`);
                });
            });

            const hideNews = count => {
                [...document.querySelectorAll('.news__item')].forEach((newsItem, newsCount) => {
                    if (newsCount < count) {
                        newsItem.removeAttribute('data-hide');
                    } else {
                        newsItem.setAttribute('data-hide', 'true');
                    }
                });
            };

            const cutNews = () => {
                if (window.matchMedia('(max-width: 1259px)').matches) {
                    if (window.matchMedia('(max-width: 768px)').matches) {
                        if (window.matchMedia('(max-width: 425px)').matches) {
                            hideNews(5);
                        } else {
                            hideNews(10);
                        }
                    } else {
                        hideNews(11);
                    }
                } else {
                    hideNews(19);
                }
            };

            cutNews();

            const optimizedResize = (function () {
                const callbacks = [];
                let running = false;

                const addCallback = callback => {
                    if (callback) {
                        callbacks.push(callback);
                    }
                }

                const runCallbacks = () => {
                    callbacks.forEach(function (callback) {
                        callback();
                    });
                    running = false;
                }

                const resize = () => {
                    if (!running) {
                        running = true;
                        if (window.requestAnimationFrame) {
                            window.requestAnimationFrame(runCallbacks);
                        } else {
                            setTimeout(runCallbacks, 66);
                        }
                    }
                }

                return {
                    add: function (callback) {
                        if (!callbacks.length) {
                            window.addEventListener('resize', resize);
                        }
                        addCallback(callback);
                    }
                }
            })();

            optimizedResize.add(cutNews);

            document.querySelector('.section--news').removeAttribute('data-loading');

        }
    }
});



/* data arrays */
const all = {
    main: [],
    american: [],
    russian: [],
    markets: []
};



/* percentage calculator */
const calcPercentage = (newValue, oldValue) => {
    return newValue > oldValue ? `+${((newValue - oldValue) / oldValue * 100).toFixed(3)}` : newValue === oldValue ? '0.000' : `−${((oldValue - newValue) / oldValue * 100).toFixed(3)}`;
};



/* convert xml array to normal */
const xml2array = xmlArray => {

    return xmlArray.reduce((accumulator, currentValue) => {

        let dailyArray = [];
        let byhourArray = [];

        const reduceDaily = array => {
            return array.reduce((dailyAccumulator, dailyCurrentValue) => {
                dailyAccumulator.push({
                    date: dailyCurrentValue._attributes.date,
                    value: dailyCurrentValue._text
                });
                return dailyAccumulator;
            }, []);
        };

        const reduceByhour = array => {
            return array.reduce((byhourAccumulator, byhourCurrentValue) => {
                byhourAccumulator.push({
                    date: byhourCurrentValue._attributes.date,
                    value: byhourCurrentValue._text
                });
                return byhourAccumulator;
            }, []);
        };

        if (currentValue.hasOwnProperty('period')) {

            if (Array.isArray(currentValue.period)) {

                /* daily */
                const dailyIndex = currentValue.period.findIndex(periodObj => periodObj._attributes.timeframe === 'daily');

                if (dailyIndex !== -1) {
                    if (Array.isArray(currentValue.period[dailyIndex].price)) {
                        dailyArray = reduceDaily(currentValue.period[dailyIndex].price)
                    } else {
                        dailyArray.push({
                            date: currentValue.period[dailyIndex].price._attributes.date,
                            value: currentValue.period[dailyIndex].price._text
                        });
                    }
                }

                /* by hour */
                const byhourIndex = currentValue.period.findIndex(periodObj => periodObj._attributes.timeframe === 'byhour');

                if (byhourIndex !== -1) {
                    if (Array.isArray(currentValue.period[byhourIndex].price)) {
                        byhourArray = reduceByhour(currentValue.period[byhourIndex].price)
                    } else {
                        byhourArray.push({
                            date: currentValue.period[byhourIndex].price._attributes.date,
                            value: currentValue.period[byhourIndex].price._text
                        });
                    }
                }

            } else {

                if (currentValue.period._attributes.timeframe === 'daily') {

                    if (Array.isArray(currentValue.period.price)) {
                        dailyArray = reduceDaily(currentValue.period.price);
                    } else {
                        dailyArray.push({
                            date: currentValue.period.price._attributes.date,
                            value: currentValue.period.price._text
                        });
                    }

                } else {

                    if (Array.isArray(currentValue.period.price)) {
                        byhourArray = reduceByhour(currentValue.period.price);
                    } else {
                        byhourArray.push({
                            date: currentValue.period.price._attributes.date,
                            value: currentValue.period.price._text
                        });
                    }

                }

            }

        }

        const humanName = currentValue._attributes.name ? currentValue._attributes.name : currentValue._attributes.ticker;

        accumulator.push({
            name: humanName,
            ticker: currentValue._attributes.ticker,
            url: currentValue._attributes.buyurl ? currentValue._attributes.buyurl : currentValue._attributes.url ? currentValue._attributes.url : '',
            daily: dailyArray,
            byhour: byhourArray
        });

        return accumulator;

    }, []);

};



/* short data */
const todayOnlyData = data => {
    return data.reduce((accumulator, currentValue, index) => {
        const beforeLastByHourElement = currentValue.byhour[currentValue.byhour.length - 2];
        const lastByHourElement = currentValue.byhour[currentValue.byhour.length - 1];
        const datetime = lastByHourElement.date.split(' ');

        accumulator.push({
            id: index,
            name: currentValue.name,
            ticker: currentValue.ticker,
            url: currentValue.url ? currentValue.url : '',
            value: lastByHourElement.value,
            change: currentValue.byhour.length > 1 ? calcPercentage(lastByHourElement.value, beforeLastByHourElement.value) : '0.000',
            date: `${datetime[0].substring(6)}.${datetime[0].substring(4, 6)}.${datetime[0].substring(0, 4)}`,
            time: datetime[1].substring(0, 5)
        });

        return accumulator;
    }, []);
};



/* print items */
const printItems = (data, position) => {
    const isFloat = n => {
        const stringNumber = n.toString();
        if (stringNumber.includes('.')) {
            const stringArray = stringNumber.split('.');
            if (stringArray[1].length > 4) {
                return true;
            }
        }
        return false;
    }

    return data.reduce((accumulator, currentValue, index) => {
        const value = isFloat(currentValue.value) ? currentValue.value.toFixed(2) : currentValue.value;
        accumulator += `
    <div class="stockunit${index === 0 ? ' stockunit--active' : ''}${position !== 'markets' ? ' stockunit--primary' : ''}" data-id=${index}><strong class="stockunit__symbol">${currentValue.name}</strong><em class="stockunit__value" data-change="${currentValue.change}">${value}</em><span class="stockunit__change" data-value="${currentValue.change}">${currentValue.change === '0.000' ? '&ensp;0.000' : currentValue.change}</span><time class="stockunit__date">${currentValue.date}</time><time class="stockunit__time">${currentValue.time}</time>${currentValue.url.length > 1 ? `<a class="stockunit__action" href="${currentValue.url}?utm_source=gazeta_ru&amp;utm_medium=botton&amp;utm_term=${currentValue.name}&amp;utm_campaign=buy_stock_shop" target="_blank" rel="noopener">Подробнее</a>` : `<button class="stockunit__action" type="button" data-ticker="${currentValue.ticker}">Купить</button>`}</div>
        ${position === 'markets' ? `<div class="stockgraph"><div class="stockgraph__graph"></div><div class="stockgraph-menu"><input class="stockgraph-menu__radio" type="radio" name="${position}${index}" id="${position}${index}day" data-id="day" checked="checked"><label class="stockgraph-menu__title" for="${position}${index}day">День</label><input class="stockgraph-menu__radio" type="radio" name="${position}${index}" id="${position}${index}week" data-id="week"><label class="stockgraph-menu__title" for="${position}${index}week">Неделя</label><input class="stockgraph-menu__radio" type="radio" name="${position}${index}" id="${position}${index}month" data-id="month"><label class="stockgraph-menu__title" for="${position}${index}month">Месяц</label></div></div>` : ''}`;
        return accumulator;
    }, '');
};



/* update graph */
const updateGraph = (data, graphContainer, index) => {



    /* container for graph */
    const container = Array.isArray(graphContainer) ? graphContainer[index] : graphContainer;



    /* day */
    const elementsInDay = array => {
        const lastElement = array[array.length - 1];
        const lastDatetime = lastElement.date.split(' ');
        for (let i = array.length - 2; i > 0; i--) {
            const currentDatetime = array[i].date.split(' ');
            if (currentDatetime[1] === lastDatetime[1]) {
                return array.length - i - 1;
            }
        }
        return 0;
    };

    const dayArrayRaw = data[index].byhour;
    const dayActualLength = elementsInDay(dayArrayRaw);
    const dayArray = dayActualLength === 0 ? dayArrayRaw : dayArrayRaw.slice(Math.max(dayArrayRaw.length - dayActualLength, 1));

    const dayData = {
        labels: [],
        series: [[]]
    };

    dayArray.forEach(dayItem => {
        const datetime = dayItem.date.split(' ');
        dayData.labels.push(datetime[1].substring(0, 2));
        dayData.series[0].push({meta: `${datetime[0].substring(6)}.${datetime[0].substring(4, 6)} ${datetime[1].substring(0, 5)}`, value: dayItem.value});
    });



    /* week */
    const weekArrayRaw = data[index].daily;
    const weekArray = weekArrayRaw.slice(Math.max(weekArrayRaw.length - 7, 1));

    const weekData = {
        labels: [],
        series: [[]]
    };

    weekArray.forEach(weekItem => {
        const datetime = weekItem.date;
        weekData.labels.push(`${datetime.substring(6)}`);
        weekData.series[0].push({meta: `${datetime.substring(6)}.${datetime.substring(4, 6)}`, value: weekItem.value});
    });



    /* month */
    const monthArrayRaw = data[index].daily;
    const monthArray = monthArrayRaw.slice(Math.max(monthArrayRaw.length - 30, 1));

    const monthData = {
        labels: [],
        series: [[]]
    };

    monthArray.forEach(monthItem => {
        const datetime = monthItem.date;
        monthData.labels.push(`${datetime.substring(6)}`);
        monthData.series[0].push({meta: `${datetime.substring(6)}.${datetime.substring(4, 6)}`, value: monthItem.value});
    });



    /* chart */
    const chart = new Chartist.Line(
        container.querySelector('.stockgraph__graph'),
        dayData,
        {
            fullWidth: true,
            showArea: true,
            plugins: [
                Chartist.plugins.tooltip()
            ]
        }
    );



    /* switch between periods */
    [...container.querySelectorAll('.stockgraph-menu__radio')].forEach((input, inputIndex) => {
        if (inputIndex === 0) {
            input.checked = true;
        }

        input.addEventListener('change', e => {

            const id = e.target.dataset.id;

            if (id === 'day') {
                chart.update(dayData);
            } else if (id === 'week') {
                chart.update(weekData);
            } else if (id === 'month') {
                chart.update(monthData);
            }

            analyticsEvent('Period', 'click', `Period: ${id}, Index: ${index}`);

        });
    });

};



/* print primary */
const printPrimary = (data, position) => {

    /* short data array */
    const shortData = todayOnlyData(data);

    /* paint stock items */
    const itemsContainer = document.querySelector(`.section-unit[data-id="${position}"] .items`);
    itemsContainer.innerHTML = printItems(shortData, position);
    new PerfectScrollbar(itemsContainer, {wheelPropagation: true});

    /* update header by data object */
    const updateHeader = dataObject => {
        /* title */
        document.querySelector(`.section-unit[data-id="${position}"] .section-unit__title`).textContent = dataObject.name;
        /* value */
        document.querySelector(`.section-unit[data-id="${position}"] .section-unit__stock .stockunit__value`).textContent = dataObject.value;
        /* change */
        document.querySelector(`.section-unit[data-id="${position}"] .section-unit__stock .stockunit__change`).innerHTML = dataObject.change;
        document.querySelector(`.section-unit[data-id="${position}"] .section-unit__stock .stockunit__change`).setAttribute('data-value', dataObject.change);
        /* time */
        document.querySelector(`.section-unit[data-id="${position}"] .section-unit__stock .stockunit__time`).textContent = dataObject.time;
    };

    /* initial header data */
    updateHeader(shortData[0]);

    /* graph containers */
    const graphContainer = document.querySelector(`.section-unit[data-id="${position}"] .stockgraph`);

    /* initial graph */
    if (data.length > 0) {
        updateGraph(data, graphContainer, 0);
    }

    /* select item */
    [...document.querySelectorAll(`.section-unit[data-id="${position}"] .stockunit`)].forEach((item, index, array) => {
        item.addEventListener('click', () => {

            array.forEach(arrayItem => {
                arrayItem.classList.remove('stockunit--active');
            });

            item.classList.add('stockunit--active');

            const itemId = parseInt(item.dataset.id);

            updateHeader(shortData[itemId]);
            updateGraph(data, graphContainer, itemId);

            analyticsEvent('Unit', 'click', `Name: ${item.querySelector('.stockunit__symbol').textContent}`);

        });
    });

};



/* markets */
const printMarkets = data => {

    /* short data array */
    const shortData = todayOnlyData(data);

    /* paint stock items */
    document.querySelector('.section--markets .items').innerHTML = printItems(shortData, 'markets')


    /* graph containers */
    const graphContainers = [...document.querySelectorAll('.section--markets .stockgraph')];

    /* initial graph */
    if (data.length > 0) {
        updateGraph(data, graphContainers, 0);
    }

    /* select item */
    [...document.querySelectorAll('.section--markets .stockunit')].forEach((item, index, array) => {
        item.addEventListener('click', () => {

            array.forEach(arrayItem => {
                arrayItem.classList.remove('stockunit--active');
            });

            item.classList.add('stockunit--active');

            updateGraph(data, graphContainers, parseInt(item.dataset.id));

        });
    });

};



/* primary xml */
axios({
    method:'get',
    url: isProd ? 'req/primary.php' : 'js/temp2.xml'
}).then(res => {

    if (res.data.length > 0) {

        /* primary array */
        const primaryArrayRaw = convert.xml2js(res.data, {compact: true, spaces: 4, nativeType: true});

        /* main tickers */
        const mainArrayRaw = primaryArrayRaw.xml.quote.filter(item => item._attributes.market === 'forex' || item._attributes.ticker === 'micex' || item._attributes.ticker === 'rts');

        /* market tickers */
        const marketsArrayRaw = primaryArrayRaw.xml.quote.filter(item => item._attributes.market === 'commodities' || item._attributes.market === 'indexes');

        /* main array */
        const mainArray = xml2array(mainArrayRaw);
        all.main = mainArray.filter(item => item.daily.length > 0 && item.byhour.length > 0);

        /* markets array */
        const marketsArray = xml2array(marketsArrayRaw);
        all.markets = marketsArray.filter(item => item.daily.length > 0 && item.byhour.length > 0);

        /* print main */
        printPrimary(all.main, 'main');
        document.querySelector('.section--primary').removeAttribute('data-loading');

        /* print markets */
        printMarkets(all.markets);
        document.querySelector('.section--markets').removeAttribute('data-loading');

        /* register dialog */
        const dialog = document.querySelector('dialog.buy');
        dialogPolyfill.registerDialog(dialog);

        /* close dialog by button */
        dialog.querySelector('.buy__close').addEventListener('click', () => {
            dialog.close();
        });

        /* close dialog by bg */
        dialog.addEventListener('click', e => {
            if (e.target === dialog) {
                dialog.close();
            }
        });

        /* click on buy button */
        [...document.querySelectorAll('button.stockunit__action')].forEach(button => {
            button.addEventListener('click', () => {
                axios({
                    method: 'get',
                    url: isProd ? 'req/form.php' : 'js/form.json'
                }).then(res => {
                    const finamJSON = res.data;

                    dialog.querySelector('form').setAttribute('name', finamJSON.name);

                    dialog.querySelector('.fieldset').innerHTML = finamJSON.controls.reduce((accumulator, currentValue) => {
                        accumulator += `${currentValue.type === 0 ? `<input type="hidden" name="${currentValue.name}" value="${currentValue.value ? currentValue.value : ''}">` : currentValue.type === 2 || currentValue.type === 3 || currentValue.type === 4 ? `<div class="buyform__field"><label class="buyform__label" for="${currentValue.name}">${currentValue.label}${currentValue.type === 4 ? '&nbsp;<small>+79998887766</small>' : ''}</label><input class="buyform__input" type="${currentValue.type === 4 ? 'tel' : currentValue.type === 3 ? 'email' : 'text'}" name="${currentValue.name}" id="${currentValue.name}" pattern="${currentValue.regex}" data-error="${currentValue.regexError}" ${currentValue.required ? 'required' : ''} maxlength="255" minlength="2"></div>` : currentValue.type === 5 ? `<div class="buyform__field buyform__field--check"><input class="buyform__checkbox" type="checkbox" name="checkbox" name="${currentValue.name}" id="${currentValue.name}" value="${currentValue.value}" ${currentValue.required ? 'required' : ''} checked><label class="buyform__checklabel" for="${currentValue.name}">${currentValue.label}</label></div>` : ''}`;
                        return accumulator;
                    }, '') + '<button class="buyform__submit" type="submit">Отправить заявку</button>';

                    dialog.querySelector('form').addEventListener('submit', e => {
                        e.preventDefault();

                        const form = e.target;

                        const xhr = new XMLHttpRequest();
                        const formData = new FormData(form);

                        xhr.addEventListener('load', () => {
                            form.querySelector('.fieldset').innerHTML = '<span>Заявка успешно отправлена</span>';
                        });

                        xhr.open('POST', 'req/send.php');
                        xhr.send(formData);

                        analyticsEvent('Form', 'submit', `demo-form-id: ${dialog.querySelector('input[name="demo-form-id"]').value}, user-id: ${dialog.querySelector('input[name="user-id"]').value}, lastname: ${dialog.querySelector('input[name="lastname"]').value}, firstname: ${dialog.querySelector('input[name="firstname"]').value}, patronymic: ${dialog.querySelector('input[name="patronymic"]').value}, email: ${dialog.querySelector('input[name="email"]').value}, phone: ${dialog.querySelector('input[name="phone"]').value}, confidential: ${dialog.querySelector('input[id="confidential"]').value}`);
                    });

                    dialog.querySelector('#lastname').focus();
                });

                dialog.showModal();

            });
        });

    }

});



/* tertiary xml */
axios({
    method:'get',
    url: isProd ? 'req/tertiary.php' : 'js/temp3.xml'
}).then(res => {

    if (res.data.length > 0) {

        const tertiaryArrayRaw = convert.xml2js(res.data, {compact: true, spaces: 4, nativeType: true});

        const americanArrayRaw = tertiaryArrayRaw.xml.quote.filter(item => item._attributes.market === 'usa');

        const americanArray = xml2array(americanArrayRaw);

        all.american = americanArray.filter(item => item.daily.length > 0 && item.byhour.length > 0);

    }
});



/* quaternary xml */
axios({
    method:'get',
    url: isProd ? 'req/quaternary.php' : 'js/temp4.xml'
}).then(res => {

    if (res.data.length > 0) {

        const quaternaryArrayRaw = convert.xml2js(res.data, {compact: true, spaces: 4, nativeType: true});

        const russianArrayRaw = quaternaryArrayRaw.xml.quote.filter(item => item._attributes.market === 'moex');

        const russianArray = xml2array(russianArrayRaw);

        all.russian = russianArray.filter(item => item.daily.length > 0 && item.byhour.length > 0);

    }
});



/* top menu */
[...document.querySelectorAll('.section--primary .section__radio')].forEach(input => {
    input.addEventListener('change', e => {
        if (e.target.dataset.id === 'american') {
            printPrimary(all.american, 'american');
        }
        if (e.target.dataset.id === 'russian') {
            printPrimary(all.russian, 'russian');
        }
    });
});



// WEBPACK FOOTER //
// ./js/main.js